export default __webpack_public_path__ + "static/media/14.d5627e15.jpg";